"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
var react_1 = require("react");
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.subscriptions = [];
        _this.toBeSubscribedIfUnMounted = [];
        _this.hasBeenUnmounted = false;
        return _this;
    }
    /**
     * Subscribe to an Event
     * This is a helpful method to keep track of your subscriptions on UnMount and Mount of the Component
     * @param {Event} event - The Event object to which you want to subscribe
     * @param {Function }callback - The callback function that's gonna be executed when it happens
     * @param {boolean}receiveLastValue - Whether the callback should receive the last value immediately
     * @return {Subscription} subscription The subscription for this event in the Store
     */
    View.prototype.subscribe = function (event, callback, receiveLastValue) {
        if (receiveLastValue === void 0) { receiveLastValue = false; }
        var subscription = event.subscribe(callback, receiveLastValue);
        this.subscriptions.push(subscription);
        // on an event where the component is unmounted and then mounted:
        this.toBeSubscribedIfUnMounted.push({ event: event, callback: callback, receiveLastValue: receiveLastValue });
        return subscription;
    };
    View.prototype.componentDidMount = function () {
        if (!this.hasBeenUnmounted)
            return;
        var that = this;
        this.toBeSubscribedIfUnMounted.forEach(function (observer) {
            var store = observer.store;
            if (store !== null && store !== undefined) {
                var subscription = store.subscribe(observer.eventName, observer.callback, observer.receiveLastValue);
                that.subscriptions.push(subscription);
            }
            else {
                var event_1 = observer.event;
                if (event_1 !== null && event_1 !== undefined) {
                    var subscription = event_1.subscribe(observer.callback, observer.receiveLastValue);
                    that.subscriptions.push(subscription);
                }
            }
        });
    };
    View.prototype.componentWillUnmount = function () {
        this.subscriptions.forEach(function (subscription) {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
        this.hasBeenUnmounted = true;
    };
    return View;
}(react_1.Component));
exports.View = View;
